import { Input, Text } from "components/base/Form";
import ItemSizeInput from "components/shared/ItemSizeInput";

const DimensionView = ({ product, setProduct }) => {
  return (
    <div className="card">
      <h5>Dimensions</h5>
      <div className="-mx-2 mt-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Size: </label>
              </td>
              <td className="w-full">
                <ItemSizeInput
                  value={product.size}
                  onChange={(size) => setProduct({ ...product, size })}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Weight: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.weight}
                  onChange={(e) =>
                    setProduct({ ...product, weight: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Pantone: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.pantone}
                  onChange={(e) =>
                    setProduct({ ...product, pantone: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label className="translate-y-1 block">Remark:</label>
              </td>
              <td className="w-full">
                <Text
                  className="w-full"
                  placeholder="Enter remark if there is any related to the product dimensions."
                  value={product.remark}
                  onChange={(e) =>
                    setProduct({ ...product, remark: e.target.value })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DimensionView;
